// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__25zMK","requiredAsterisk":"Info_requiredAsterisk__3sPDS"};